import moment from "moment"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createReaction, deleteReaction, getIdeaDetail } from "../../services/ideas.service"
import { ideaModelDataActions } from "../../store/ideaModelData"
import { Comments } from "../comments/comments.component"

export const OpenIdeaDialog = () => {

    const dispatch = useDispatch()
    const ideaId = useSelector(state => state.ideaModelData.id)

    const [idea, setIdea] = useState()

    const [attachments, setAttachments] = useState([])

    const [showDialog, setShowDialog] = useState(false)

    const [reaction, setReaction] = useState("")
    const [heartsCount, setHeartsCount] = useState(0)
    const [likesCount, setLikesCount] = useState(0)
    const [dislikeCount, setDislikeCounts] = useState(0)

    const changeReaction = async action => {
        if (action === reaction) {
            setReaction("")
            // deleteReaction(reactionId)
            decreaseReaction(reaction)
        }
        else {
            // await createReaction(reactionId, ideaId, action)
            setReaction(action)
            decreaseReaction(reaction)
            increaseReaction(action)
        }
    }

    const increaseReaction = (action,) => {
        switch (action) {
            case 'heart':
                setHeartsCount(heartsCount + 1)
                break;
            case 'like':
                setLikesCount(likesCount + 1)
                break;
            case 'dislike':
                setDislikeCounts(dislikeCount + 1)
                break
            default:
                break
        }
    }

    const decreaseReaction = (action) => {
        switch (action) {
            case 'heart':
                setHeartsCount(heartsCount - 1)
                break;
            case 'like':
                setLikesCount(likesCount - 1)
                break;
            case 'dislike':
                setDislikeCounts(dislikeCount - 1)
                break
            default:
                break
        }
    }


    const getIdeaData = async () => {
        if (ideaId) {
            const { status, data } = await getIdeaDetail(ideaId)
            if (status == 200) {
                setIdea(data)
                setAttachments(data.attachments)
                setReaction(data.reactionType)
                setHeartsCount(data.hearts)
                setLikesCount(data.likes)
                setDislikeCounts(data.dislikes)
                setShowDialog(true)
                console.log(data)
            }
        }
        else {
            setTimeout(() => {
                setShowDialog(false)
            },300)
        }
    }

    useEffect(() => {
        getIdeaData()
    }, [ideaId])

    return (
        <div
            className="modal fade text-left"
            id="tideas"
            role="dialog"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="text-uppercase mb-0">
                            <span className="star-orange">trending</span> ideas
                        </h2>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => dispatch(ideaModelDataActions.setId(null))}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    {showDialog &&
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-8 col-12 idea-modal overflow-hidden">
                                    <div id="carouselControls2" className="carousel slide carousel-fade" data-interval="false" data-ride="carousel">
                                        <div className="carousel-inner">
                                            {
                                                idea.attachments.map((attachment, index) => {
                                                    
                                                    let attachmentTag
                                                    if (attachment.ATTACHMENT_TYPE == '.mp4') {
                                                        attachmentTag = <video className="d-block w-100 h-500p Player" src={attachment.ATTACHMENT} controls></video>
                                                    }
                                                    else if (attachment.ATTACHMENT_TYPE == ".mp3") {
                                                        attachmentTag = <div className="w-100 h-500p"><img src={""} className="aud-img" alt="img" /><audio className="aud-player" src={attachment.ATTACHMENT} controls></audio></div>
                                                    }
                                                    else if (attachment.ATTACHMENT_TYPE == ".pdf") {
                                                        attachmentTag = <iframe className="d-block w-100 h-500p" src={attachment.ATTACHMENT} controls></iframe>
                                                    }
                                                    else {
                                                        attachmentTag = <img className="d-block w-100 h-500p" src={attachment.ATTACHMENT}></img>
                                                    }

                                                    const isActive = index == 0 ? "active" : ""
                                                    return (
                                                        <div className={`carousel-item ` + isActive} key={index}>
                                                            {attachmentTag}
                                                        </div>
                                                    )
                                                }
                                                )}
                                        </div>
                                        <a className="carousel-control-prev" href="#carouselControls2" role="button" data-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="false"></span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                        <a className="carousel-control-next" href="#carouselControls2" role="button" data-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-12 idea-modal">
                                    <div className="media">
                                        <div className="starshot-ring mr-1">
                                            <div className="avatar">
                                                <div className="text-icon font-lato">{idea.EMP_NAME[0]}</div>
                                            </div>
                                        </div>
                                        <div className="media-body my-auto">
                                            <p className="mb-0 font-lato">{idea.EMP_NAME}</p>
                                            <p className="mb-0 font-lato font-10 star-orange">
                                                {moment(idea.createdAt).fromNow()}
                                            </p>
                                        </div>
                                    </div>
                                    <p className="card-text font-lato font-12 mt-1">
                                        {idea.IDEA_DETAIL}
                                    </p>
                                    {/* <div className="card">
                                        <div className="card-body d-flex text-center pa-5">
                                            <p className="line-height-10 mb-0 w-33">
                                                <i className={`fas fa-heart ${reaction == 'heart' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction("heart")}  />
                                                <br />
                                                <span className="font-lato font-10 opacity-50" >{heartsCount}</span>
                                            </p>
                                            <span className="vr" />
                                            <p className="line-height-10 mb-0 w-33">
                                                <i className={`fas fa-thumbs-up ${reaction == 'like' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction('like')} />
                                                <br />
                                                <span className="font-lato font-10 opacity-50">{likesCount}</span>
                                            </p>
                                            <span className="vr" />
                                            <p className="line-height-10 mb-0 w-33">
                                                <i className={`fas fa-thumbs-down ${reaction == 'dislike' ? "text-primary reaction-pop" : "opacity-50"}`} style={{ cursor: 'pointer' }} onClick={e => changeReaction("dislike")} />
                                                <br />
                                                <span className="font-lato font-10 opacity-50">{dislikeCount}</span>
                                            </p>
                                        </div>
                                    </div> */}
                                    {/* <div className="card" tabIndex={1}>
                                    <div className="card-header py-1">
                                        <small className="text-muted font-lato">13 Comments</small>
                                    </div>
                                    <div
                                        className="card-body"
                                        style={{ height: 180, overflow: "auto" }}
                                    >
                                        <ul className="list-unstyled">
                                            <li>
                                                <div className="d-flex align-items-start mb-1">
                                                    <div className="avatar mr-1">
                                                        <img
                                                            src="assets/images/male.svg"
                                                            alt="img"
                                                            height={34}
                                                            width={34}
                                                        />
                                                    </div>
                                                    <div className="profile-user-info">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <p className="mb-0 font-lato font-12 font-weight-600">
                                                                Jaideep Chawla
                                                            </p>
                                                            <span className="align-middle opacity-50 font-lato font-10">
                                                                8h ago
                                                            </span>
                                                        </div>
                                                        <p className="mb-0 card-text font-lato font-12">
                                                            Cras gravida bibendum dolor eu varius. Ipsum fermentum
                                                            velit nisl, eget vehicula. Cras gravida bibendum dolor
                                                            eu varius.
                                                        </p>
                                                        <div className="d-flex align-items-start">
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-12 text-p-green font-weight-600 mr-1"
                                                            >
                                                                REPLY
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-up" />
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-p-dark-blue font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ul className="list-unstyled pl-3">
                                                    <li>
                                                        <div className="d-flex align-items-start mb-1">
                                                            <div className="avatar mr-1">
                                                                <img
                                                                    src="assets/images/male.svg"
                                                                    alt="img"
                                                                    height={34}
                                                                    width={34}
                                                                />
                                                            </div>
                                                            <div className="profile-user-info">
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className="mb-0 font-lato font-12 font-weight-600">
                                                                        Jaideep Chawla
                                                                    </p>
                                                                    <span className="align-middle opacity-50 font-lato font-10">
                                                                        8h ago
                                                                    </span>
                                                                </div>
                                                                <p className="mb-0 card-text font-lato font-12">
                                                                    Cras gravida bibendum dolor eu varius. Ipsum
                                                                    fermentum velit nisl, eget vehicula. Cras gravida
                                                                    bibendum dolor eu varius.
                                                                </p>
                                                                <div className="d-flex align-items-start">
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-12 text-p-green font-weight-600 mr-1"
                                                                    >
                                                                        REPLY
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                                    >
                                                                        <i className="fas fa-thumbs-up" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                                    >
                                                                        <i className="fas fa-thumbs-down" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="d-flex align-items-start mb-1">
                                                            <div className="avatar mr-1">
                                                                <img
                                                                    src="assets/images/male.svg"
                                                                    alt="img"
                                                                    height={34}
                                                                    width={34}
                                                                />
                                                            </div>
                                                            <div className="profile-user-info">
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className="mb-0 font-lato font-12 font-weight-600">
                                                                        Jaideep Chawla
                                                                    </p>
                                                                    <span className="align-middle opacity-50 font-lato font-10">
                                                                        8h ago
                                                                    </span>
                                                                </div>
                                                                <p className="mb-0 card-text font-lato font-12">
                                                                    Cras gravida bibendum dolor eu varius. Ipsum
                                                                    fermentum velit nisl, eget vehicula. Cras gravida
                                                                    bibendum dolor eu varius.
                                                                </p>
                                                                <div className="d-flex align-items-start">
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-12 text-p-green font-weight-600 mr-1"
                                                                    >
                                                                        REPLY
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                                    >
                                                                        <i className="fas fa-thumbs-up" />
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                                    >
                                                                        <i className="fas fa-thumbs-down" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <div className="d-flex align-items-start mb-1">
                                                    <div className="avatar mr-1">
                                                        <img
                                                            src="assets/images/male.svg"
                                                            alt="img"
                                                            height={34}
                                                            width={34}
                                                        />
                                                    </div>
                                                    <div className="profile-user-info">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <p className="mb-0 font-lato font-12 font-weight-600">
                                                                Jaideep Chawla
                                                            </p>
                                                            <span className="align-middle opacity-50 font-lato font-10">
                                                                8h ago
                                                            </span>
                                                        </div>
                                                        <p className="mb-0 card-text font-lato font-12">
                                                            Cras gravida bibendum dolor eu varius. Ipsum fermentum
                                                            velit nisl, eget vehicula. Cras gravida bibendum dolor
                                                            eu varius.
                                                        </p>
                                                        <div className="d-flex align-items-start">
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-12 text-p-green font-weight-600 mr-1"
                                                            >
                                                                REPLY
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-up" />
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex align-items-start mb-1">
                                                    <div className="avatar mr-1">
                                                        <img
                                                            src="assets/images/male.svg"
                                                            alt="img"
                                                            height={34}
                                                            width={34}
                                                        />
                                                    </div>
                                                    <div className="profile-user-info">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <p className="mb-0 font-lato font-12 font-weight-600">
                                                                Jaideep Chawla
                                                            </p>
                                                            <span className="align-middle opacity-50 font-lato font-10">
                                                                8h ago
                                                            </span>
                                                        </div>
                                                        <p className="mb-0 card-text font-lato font-12">
                                                            Cras gravida bibendum dolor eu varius. Ipsum fermentum
                                                            velit nisl, eget vehicula. Cras gravida bibendum dolor
                                                            eu varius.
                                                        </p>
                                                        <div className="d-flex align-items-start">
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-12 text-p-green font-weight-600 mr-1"
                                                            >
                                                                REPLY
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-p-dark-blue font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-up" />
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="card-text font-lato font-14 text-grey font-weight-600 mr-1"
                                                            >
                                                                <i className="fas fa-thumbs-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-footer bg-comments-card-footer py-1">
                                        <div className="d-flex justify-content-start align-items-center">
                                            <div className="avatar mr-1">
                                                <img
                                                    src="assets/images/male.svg"
                                                    alt="img"
                                                    height={34}
                                                    width={34}
                                                />
                                            </div>
                                            <div className="input-group input-group-merge mr-1 form-send-message">
                                                <input
                                                    type="text"
                                                    className="form-control bg-white"
                                                    placeholder="Add a comment"
                                                />
                                                <a className="input-group-append">
                                                    <i className="fas fa-paper-plane bg-white text-p-green input-group-text" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                    {/* <Comments data={idea.}/> */}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}